const collectSearchText = (value, parts) => {
  if (value == null || value === '') return;
  if (typeof value === 'string' || typeof value === 'number') {
    parts.push(String(value));
    return;
  }
  if (Array.isArray(value)) {
    value.forEach((entry) => collectSearchText(entry, parts));
    return;
  }
  if (typeof value === 'object') {
    collectSearchText(value.full_name, parts);
    collectSearchText(value.name, parts);
    collectSearchText(value.document_title, parts);
    collectSearchText(value.file_name, parts);
    collectSearchText(value.email, parts);
  }
};

export const matchesDocumentSearch = (file, term, extra = []) => {
  const needle = String(term || '').trim().toLowerCase();
  if (!needle || !file) return true;

  const parts = [];
  [
    file.document_title,
    file.title,
    file.name,
    file.file_name,
    file.folder_name,
    file.reference_number,
    file.document_reference_number,
    file.category_name,
    file.share_name,
    file.shared_by,
    file.uploaded_by_name,
    ...extra,
  ].forEach((value) => collectSearchText(value, parts));

  return parts.join(' ').toLowerCase().includes(needle);
};
